import { render, staticRenderFns } from "./giftcard-ats-popup.vue?vue&type=template&id=ec0f1518&scoped=true&"
import script from "./giftcard-ats-popup.vue?vue&type=script&lang=js&"
export * from "./giftcard-ats-popup.vue?vue&type=script&lang=js&"
import style0 from "./giftcard-ats-popup.vue?vue&type=style&index=0&id=ec0f1518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0f1518",
  null
  
)

export default component.exports